var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonSubtractEnabled = function SvgButtonSubtractEnabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button - Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 3.99994C12.96 3.99994 4 12.9599 4 23.9999C4 35.0399 12.96 43.9999 24 43.9999C35.04 43.9999 44 35.0399 44 23.9999C44 12.9599 35.04 3.99994 24 3.99994ZM32 25.9999H16C14.9 25.9999 14 25.0999 14 23.9999C14 22.8999 14.9 21.9999 16 21.9999H32C33.1 21.9999 34 22.8999 34 23.9999C34 25.0999 33.1 25.9999 32 25.9999Z",
    fill: "#0A446D"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonSubtractEnabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ButtonSubtractEnabled.b16e202f.svg";
export { ForwardRef as ReactComponent };